<era-device-grid-item-ui [isSelected]="isSelected$ | async"
                         [device]="device()"
                         [hasWarning]="hasWarning$ | async"
                         [osUpdateStatus]="osUpdateStatus$ | async"
                         [isApplicationInSync]="isApplicationInSync$ | async"
                         [isInUse]="isInUse$ | async">
</era-device-grid-item-ui>